(ns com.theplantscape.local-store.ensemble
  (:require
   [com.theplantscape.local-store.core-db :as db]
   [com.theplantscape.local-store.utils :as u]
   [com.theplantscape.local-store.polyculture-db :as c]
   [com.theplantscape.local-store.plants-db :as p]
   [com.theplantscape.local-store.diagram-db :as d]))

;; local diagram db

(defonce diag db/diag)
(defn reset-database [] (d/reset-database))
(defn load-database [datoms] (d/load-database datoms))
(defn reset [] (d/reset))

(defn remove-namespace-map [hm]
  (u/remove-namespace-map hm))

(defn namespace-map [hm-ns hm]
  (u/namespace-map hm-ns hm))

(defn nearest-point
  ([xy] (d/nearest-point xy))
  ([attribute xy ] (d/nearest-point attribute xy)))
(defn add-new-plant [plant]
  (d/add-new-plant plant ))

(defn add-new-diagram-object
  ([type coords] (add-new-diagram-object type coords {}))
  ([type coords data]
   (prn data)
   (d/add-new-diagram-object type coords data)))

(defn plant-exists? [plant-entity-id] (p/plant-exists? plant-entity-id))
(defn insert-plant-data [plant] (p/insert-plant-data plant))
(defn get-plant-entity-id-from-uuid [plant-xt-id] (p/get-plant-entity-id-from-uuid plant-xt-id))
(defn insert-polyculture-data [poly] (c/insert-polyculture-data poly))

(defn select-plant [type] (d/select-plant type))
(defn select-patch [type] (d/select-structure type))
(defn select-structure [type] (d/select-structure type))
(defn placed-plants [] (d/placed-plants))
(defn placed-plant-eids [] (d/placed-plant-eids))
(defn plant-types [] (d/plant-types))
(defn set-diagram-properties [values] (d/set-diagram-properties values))
(defn set-diagram-id [id] (d/set-diagram-id id))
(defn set-colour [eid colour] (d/set-colour eid colour))
(defn rm-entity [entity-id] (d/rm-entity entity-id))
(defn update-entity [eid attr value] (d/update-entity eid attr value))
(defn insert-objects [objects] (d/insert-objects objects))
(defn insert-diagram-data [] (d/insert-diagram-data))
(defn diagrams [] (d/diagrams))
(defn layers [] (d/layers))
(defn fetch-diagram-id [] (d/fetch-diagram-id))
(defn fetch-plant [plant] (d/fetch-plant plant))
(defn fetch-plant-related [plant-entity-id] (d/fetch-plant-related plant-entity-id))
(defn fetch-plant-eid-from-uuid [uuid] (d/fetch-plant-eid-from-uuid uuid))
(defn fetch-diagram-version [] (d/fetch-diagram-version))
(defn fetch-diagram-settings [] (d/fetch-diagram-settings))
(defn fetch-diagram-plants [] (d/fetch-diagram-plants))
(defn store-diagram-settings [diagram] (d/store-diagram-settings diagram))
